import React, { FC } from "react";
import { Form, Input } from "antd";
import { IPaymentPageCustomAttribute } from "@app-models";

interface GenericAttributeFieldProps {
  name: string;
  attribute: IPaymentPageCustomAttribute;
  index: number;
}

const GenericAttributeField: FC<GenericAttributeFieldProps> = ({ name, attribute, index }) => {
  return (
    <div className="name-field field-title-case">
      <Form.Item
        name={name}
        rules={[
          {
            required: attribute.mandatory,
            message: "Field is mandatory",
          },
        ]}
      >
        <div className="name-field-2">
          <label className="form-label-style">{attribute.fieldName}</label>
          <Input
            type={attribute.validationType === "FILE_UPLOAD" ? "file" : attribute.validationType}
            className="form-input-style"
            placeholder={attribute.fieldName}
          />
        </div>
      </Form.Item>
    </div>
  );
};

export default GenericAttributeField;
